import React from "react";

import { getValue } from "components/Screens/CommonUtils";

export default function EmployeeContactInfo({ employeeDetails }) {
  const contactInfo = [
    { label: "Phone number", value: employeeDetails?.phoneNumber },
    { label: "Personal email address", value: employeeDetails?.personalEmail },
    { label: "Registered email address", value: employeeDetails?.email },
  ];
  const fullAddress = [
    employeeDetails?.addressLine1,
    employeeDetails?.zip,
    employeeDetails?.city,
    employeeDetails?.state,
    employeeDetails?.country,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      <div className="flex flex-wrap">
        {contactInfo.map((info) => (
          <div key={info.label} className="w-50p mt-1">
            <p className="text-headings-secondary heading-h5-regular block">{info.label}</p>
            <p className="color-text-body-secondary para-body-m-medium block">{getValue(info.value)}</p>
          </div>
        ))}
      </div>
      <div className="mt-1">
        <p className="text-headings-secondary heading-h5-regular block">Residential address</p>
        <p className="color-text-body-secondary para-body-m-medium block">{getValue(fullAddress)}</p>
      </div>
    </>
  );
}
